export interface EnvConfig {
    API_BASE_URL: string,
    FE_BASE_URL: string,
    API_URL: string,
    EPAY_URL: string,
}

export const TRAVEL_PACKAGES = ['L','S','V','P'];

export const CONFIGS = {
    'TITLE': 'DZI-MTPL',
    'QUERY_LIMIT': 10,
    'CURRENCY': 'BGN',
    'MTPL_PURCHASE_GENERAL_TERM': 'https://www.kbc.ie/terms-and-conditions',
    'MTPL_CALC_SUMMARY_EDIT': 1,
    'MTPL_PURCHASE_OVERVIEW_EDIT': 2,
    'DELIVERY_CURRENT_ADDRESS': 'currentAddress',
    'DELIVERY_OTHER_ADDRESS': 'otherAddress',
    'PAGE_NOT_FOUND_TITLE':'DZI Page Not Found',
    'CLAIMS': 'Claims',
    'E_SIGN_SUCCESS':'success',
    'E_SIGN_FAIL':'fail',
    'PHONE_NUMBER_PREFIX': '+359',
    'PROPERTY_SIGN_UP_DATA':'Property_SignUp_Data'
};

export const FLOW = {
  'UBB': 'UBB'
}

export const ASSET_PATH = {
    'USER_DASHBORD_HEADER_JSON':'../assets/json-file/UserDashboardHeadersMenuFirstRelease.json',
    'PROPERTY_TYPE_JSON':'../assets/json-file/PropertyDataList.json',
    'PAGE_NOT_FOUND_JSON_PATH':'../assets/json-file/PageNotFound.json',
    'PROPERTY_TERM_DURATION_JSON':'../assets/json-file/PropertyTermDuration.json',
    'TRAVEL_MAPPING_RESPONSE_JSON':'../assets/json-file/TravelMappingResponse.json',
    'TYPE_OF_TRAVEL_MAPPING_JSON':'../assets/json-file/TypeOfTravelMapping.json',
    'TYPE_OF_WORK_ABROAD_MAPPING_JSON':'../assets/json-file/TypeOfWorkAbroadMapping.json',
    'REASON_FOR_TRAVEL_MAPPING_JSON':'../assets/json-file/ReasonForTravelMapping.json',

}

export const LANGUAGE = {
    'ENGLISH': 'en',
    'BULGARIAN': 'bg',
};

export const EPAY_MTPL = {
    'PAYMENT_SUCCESS_URL':  '/mtpl/purchase-policy/payment?success=1',
    'PAYMENT_FAILURE_URL':  '/mtpl/purchase-policy/payment-result?success=0',
    'PAYMENT_SUCCESS_URL_EN': '/en/mtpl/purchase-policy/payment?success=1',
    'PAYMENT_FAILURE_URL_EN': '/en/mtpl/purchase-policy/payment-result?success=0',
};

export const EPAY_POLICY_PAYMENT = {
  'PAYMENT_SUCCESS_URL':  '/policy-payment/payment-result?success=1',
  'PAYMENT_FAILURE_URL':  '/policy-payment/payment-result?success=0',
  'PAYMENT_SUCCESS_URL_EN': '/en/policy-payment/payment-result?success=1',
  'PAYMENT_FAILURE_URL_EN':  '/en/policy-payment/payment-result?success=0',
};

export const EPAY_TRAVEL_INSURANCE = {
  'PAYMENT_SUCCESS_URL': '/travel/purchase-policy/travel-payment?success=1',
  'PAYMENT_FAILURE_URL':  '/travel/purchase-policy/payment-result?success=0',
  'PAYMENT_SUCCESS_URL_EN': '/en/travel/purchase-policy/travel-payment?success=1',
  'PAYMENT_FAILURE_URL_EN':  '/en/travel/purchase-policy/payment-result?success=0',
};

export const BORICA_INSIS_ERROR = {
    'IN_PROGRESS': 'IN_PROGRESS',
    'SIGNED': 'SIGNED',
    'SIGNED_BY_CLIENT': 'SIGNED_BY_CLIENT',
    'REJECTED': 'REJECTED',
    'ERROR':'ERROR'
}

export const LANDING_FROM_MAIL = {
    'MTPL_ADDITIONAL_COVERS': 'additional_cover',
    'MTPL_CALC_SUMMARY_TYPE': 'calculator_summary',
    'MTPL_PURCHAGE_SUMMARY_TYPE': 'overview',
    'PROP_ADDITIONAL_COVERS': 'additional_cover',
    'PROP_CALC_SUMMARY_TYPE': 'calculator_summary',
    'PROP_PURCHAGE_SUMMARY_TYPE': 'overview',
    'TRAVEL_CALC_SUMMARY_TYPE': 'calculator_summary',
    'TRAVEL_PURCHAGE_SUMMARY_TYPE': 'overview',
};

export const DUE_INSTALMENT_SCREEN = {
    'STAND_ALONE_PAY': 'STAND_ALONE_PAY',
    'USER_DUE_INSTALMENT': 'USER_DUE_INSTALMENT',
};

export const INSURANCE: Record<string, number> = {
    'MTPL': 4600,
    'CASCO': 4700,
    'Property_Insurance': 1112,
    'TRAVEL': 8100,
    'INSURED_PEOPLE': 1,
    'MTPL_INSIS9': 4307
};

export enum PaymentMethod {
    'VPOS' = 'VPOS',
    'Epay' = 'Epay',
}

export type ApiProductCodes = 4600 | 1112 | 8100;
export type ApiPaymentMethods = 'VPOS' | 'Epay';

export const POLICY_BTN = {
     'RESUME_BTN' : 'Resume',
     'DISCARD_BTN' : 'Discard',
     'RENEW_BTN' : 'Renew',
     'VIEW_POLICY' : 'View Policy',
     'PAY_INSTALMENT': 'Pay Instalment',
     'PRINT_POLICY': 'Print Policy'
}


export const EPAY_PROPERTY = {
    'PAYMENT_SUCCESS_URL': '/property-insurance/purchase-policy/payment?success=1',
    'PAYMENT_FAILURE_URL': '/property-insurance/purchase-policy/payment-error',
    'PAYMENT_SUCCESS_URL_EN': '/en/property-insurance/purchase-policy/payment?success=1',
    'PAYMENT_FAILURE_URL_EN': '/en/property-insurance/purchase-policy/payment-error',
};

export const RESTRICTED_VEHICLE = [
    '7','12'
]

export const TALON_ACTION = {
  'UPLOAD': 'upload',
  'DELETE': 'delete',
  'FRONT_SIDE': 'front',
  'BACK_SIDE':'back',
  'TALON': 'talon',
  'CLAIM_DOCUMENT': 'claim-document',
  'CLAIM_PHOTOS': 'claim-photos',
}

export const POLICY_CREATION_PROCESS_CONFIG = {
    CHECK_POLICY_CREATION_STATUS_CHECK_INTERVAL: 10 * 1000,
    CHECK_POLICY_CREATION_STATUS_TIMEOUT_INTERVAL: 10 * 60 * 1000,
}

export const PROPERTY_PAYMENT_POLICY_TERM = {
  ANNUAL: 'Annual',
  TERMLESS: 'Termless',
}


export const LOADER_MSG = {
  LOADING: 'Loading',
  PRICE_RECALC: 'Price Recalculating'
}

export const RELATIONSHIP = ['Family Numbers', 'None'];


export enum DownloadFileType {
  MAIN_POLICY = 'mainPolicy',
  PAYMENT_RECEIPT = 'paymentReceipt',
  MTPL_GTC = 'mtplGTC',
  MTPL_GC = 'mtplGC',
  MTPL_TALON = 'mtplTalon',
  PROPERTY_OU = 'propertyOU',
  PROPERTY_QUESTIONNAIRE = 'propertyQuestionnaire',
  TRAVEL_QUESTIONARY = 'travelQuestionary',
  TRAVEL_CERTIFICATE = 'travelCertificate',
  TRAVEL_INSUREDS = 'travelInsureds',
}


export enum DOCUMENT_FILE_NAME {

  MAIN_POLICY = 'Policy Document',
  PAYMENT_RECEIPT = 'Payment Receipt',
  MTPL_GTC = 'General terms and conditions',
  MTPL_GC = 'GC Document',
  MTPL_TALON = 'Talon Annual Inspection',
  PROPERTY_OU = 'General terms and conditions',
  PROPERTY_QUESTIONNAIRE = 'Questionnaire',
  TRAVEL_QUESTIONARY = 'Questionnaire',
  TRAVEL_CERTIFICATE = 'Certificates',
  TRAVEL_INSUREDS = 'List',
}


export enum OTHER_PROPERTY_TYPE {
  HOUSE_HOLD_PROPERTY =  '113.1.1'
}


export enum PAYMENT_ERROR_CONFIG {
  CONTACT_SUPPORT = 'Contact Support',
  GO_TO_HOME = 'Go to home',
  GO_TO_HOME_GUEST_URL = 'dashboard/insurance-services',
  GO_TO_HOME_LOGGED_USER_URL = 'dashboard/home/user-info',
}
